import api from './api';

export interface ClothingItem {
  id: number;
  title: string;
  description?: string;
  price?: number;
  currency?: string;
  image_url: string;
  url?: string;
  is_active?: boolean;
  display_order?: number;
  created_at?: string;
  updated_at?: string;
}

export interface ClothingResponse {
  data: ClothingItem[];
}

// Public endpoint - get all active clothing items
export const getClothing = async (): Promise<ClothingItem[]> => {
  const response = await api.get<ClothingResponse>('/clothing');
  return response.data.data;
};

// Admin endpoint - get all clothing items
export const getClothingAdmin = async (): Promise<ClothingItem[]> => {
  const response = await api.get<ClothingResponse>('/admin/clothing');
  return response.data.data;
};

// Admin endpoint - create clothing item
export const createClothing = async (data: Partial<ClothingItem>): Promise<ClothingItem> => {
  const response = await api.post<ClothingItem>('/admin/clothing', data);
  return response.data;
};

// Admin endpoint - update clothing item
export const updateClothing = async (id: number, data: Partial<ClothingItem>): Promise<ClothingItem> => {
  const response = await api.put<ClothingItem>(`/admin/clothing/${id}`, data);
  return response.data;
};

// Admin endpoint - delete clothing item
export const deleteClothing = async (id: number): Promise<void> => {
  await api.delete(`/admin/clothing/${id}`);
};

// Admin endpoint - update display order
export const updateClothingOrder = async (items: Array<{ id: number; display_order: number }>): Promise<void> => {
  await api.post('/admin/clothing/reorder', items);
};
